// extracted by mini-css-extract-plugin
export default {"movieInfo":"MoviePage_movieInfo__z5G+Z","header":"MoviePage_header__afMFC","aboutMovie":"MoviePage_aboutMovie__nQUnN","image":"MoviePage_image__Wrg9y"};